<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <h4 class="mb-0 font-size-18">{{ GetWordText(title)}}</h4>
      <div class="page-title-right">
        <ol class="breadcrumb m-0">
          <ng-container *ngFor="let item of breadcrumbItemsList">
            <li class="breadcrumb-item" *ngIf="!item.active"><a href="javascript: void(0);">{{ GetWordText(item.label) }}</a>
            </li>
            <li class="breadcrumb-item active" *ngIf="item.active">{{ GetWordText(item.label) }}
            </li>
          </ng-container>
        </ol>
      </div>
    </div>
  </div>
</div>
